<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row>
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <div class="text-h4 mb-2">Cadastro de Token</div>
      <v-row>
        <v-col cols="6">
          <v-text-field
            dense
            :value="form.name.toUpperCase()"
            :counter="30"
            label="Descrição"
            outlined
            :error-messages="nameErrors"
            @input="
              $v.form.name.$touch()
              form.name = $event.toUpperCase().trim()
            "
            @blur="$v.form.name.$touch()"
          />
        </v-col>
      </v-row>
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'

import { validateData, validateComputed } from '../_validates'
import tokenHttpServices from '../_services/tokenHttpServices'

export default {
  name: 'CadastroToken',
  components: { Snackbar, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    snackbar: false,
    text: '',
    showSkeleton: false,
    pararLoader: {
      parar: false,
    },
    form: {
      name: '',
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
  },

  methods: {
    async salvar() {
      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      this.pararLoader.parar = false

      try {
        const response = await tokenHttpServices.postNewToken(this.form)
        let validaWarning = window.confirm(
          'Por favor, anote seu token gerado. Vocé não poderá mais vê-lo após a confirmação.'
        )
        if (validaWarning) {
          let validaTokenAnotado = window.confirm(`Seu token: ${response.data.api_token}`)
          if (validaTokenAnotado) {
            this.$router.push({ name: 'TokenHome' })
          }
        }
      } catch (error) {
        console.log(error)
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'TokenHome' })
    },
  },
}
</script>
